<template>
  <main id="client" class="page-container" v-if="$route.name === 'customers'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->
    <div class="table-container-clients">
      <div class="clients-toolbar">
        <router-link to="/home/clients/add-client" class="primary-btn">
          <i class="fa-solid fa-plus"></i> Nuovo cliente
        </router-link>
        <button
          class="refresh-btn"
          :class="{ refreshed }"
          @click="handleRefresh"
          :disabled="refreshing"
          title="Aggiorna"
        >
          <i
            :class="[
              'fa-solid',
              refreshed ? 'fa-check' : 'fa-arrows-rotate',
              { 'fa-spin': refreshing },
            ]"
          ></i>
          <span>{{
            refreshing ? "Aggiorna…" : refreshed ? "Aggiornato!" : "Aggiorna"
          }}</span>
        </button>
      </div>

      <div class="tbl-wrap">
        <table class="tbl tbl-elenco client-table">
          <thead>
            <tr>
              <th id="nome-cliente">Cliente</th>
              <th id="sede" class="col-p3">Indirizzo</th>
              <th id="ultimo-preventivo" class="col-p2">Ultimo preventivo</th>
              <th class="actions-col" style="text-align: left">Azioni</th>
            </tr>
          </thead>

          <tbody>
            <!-- due <tr> per cliente come prima -->
            <template v-for="(client, index) in allClients" :key="index">
              <tr
                class="client-row riga-cliccabile"
                tabindex="0"
                @click="
                  apriDettaglio($event, client.clientName, () =>
                    dettaglioCliente(client)
                  )
                "
                @keydown.enter="
                  apriDettaglio($event, client.clientName, () =>
                    dettaglioCliente(client)
                  )
                "
              >
                <td>{{ client.clientName }}</td>

                <td class="address-cell col-p3">
                  <!-- [sc-48860] sede legale, residenza e cantiere: si vede
                       l'etichetta, il click apre l'indirizzo (link a Maps) -->
                  <details
                    v-for="v in indirizziCliente(client)"
                    :key="v.etichetta"
                    class="address-extra"
                    @toggle="
                      indirizziAperti[`${client.id}-${v.etichetta}`] =
                        $event.target.open
                    "
                  >
                    <summary
                      :title="
                        (indirizziAperti[`${client.id}-${v.etichetta}`]
                          ? 'Nascondi '
                          : 'Espandi ') + v.nome
                      "
                    >
                      {{ v.etichetta }}
                    </summary>
                    <a
                      :href="v.link"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="custom-link"
                      >{{ formatAddress(v.address) }}</a
                    >
                  </details>
                  <span v-if="!indirizziCliente(client).length"
                    >Indirizzo non disponibile</span
                  >
                </td>

                <td class="date-cell col-p2">
                  <template v-if="client.lastQuote">
                    <span class="cell-main">{{
                      formatToLocalDate(client.lastQuote)
                    }}</span>
                    <span class="cell-sub">{{
                      formatToLocalDateAndHours(client.lastQuote).split(" ")[1]
                    }}</span>
                  </template>
                  <template v-else>
                    <span>Nessun preventivo</span>
                  </template>
                </td>

                <td class="actions-cell">
                  <AzioniRiga>
                    <button
                      class="icons-button"
                      @click="showSoldItems(client)"
                      title="Articoli venduti/da ordinare"
                      aria-label="Articoli venduti/da ordinare"
                    >
                      <i class="fa-solid fa-box"></i>
                    </button>
                    <button
                      class="icons-button"
                      @click="goToEditClient(client.id)"
                      title="Modifica cliente"
                      aria-label="Modifica cliente"
                    >
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      class="icons-button icons-button--danger"
                      @click="openArchiveModal(client)"
                      title="Archivia cliente"
                      aria-label="Archivia cliente"
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </AzioniRiga>
                </td>
              </tr>
            </template>
            <tr v-if="allClients.length === 0 && !isLoading">
              <td colspan="4" class="no-result">Nessun cliente trovato.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginazione / search -->
      <div class="pagination">
        <div class="pagination-left">
          <div class="search-container">
            <i
              v-if="!searchTerm"
              class="fa-solid fa-magnifying-glass search-icon"
            ></i>
            <input
              type="text"
              v-model="searchTerm"
              @keyup.enter="onSearch"
              placeholder="Cerca clienti..."
              class="search-box"
            />
            <button
              v-if="searchTerm"
              @click="onResetSearch"
              class="clear-search-button"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
        </div>

        <div class="pagination-right">
          <div class="pagination-info">
            {{ pagination.startItem }}-{{ pagination.endItem }} di
            {{ pagination.totalItems }}
          </div>

          <div class="pagination-controls">
            <button
              class="icons-button"
              @click="goToPage(1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla prima pagina'
              "
            >
              <i class="fa-solid fa-angles-left"></i>
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage - 1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla pagina precedente'
              "
            >
              <i class="fa-solid fa-chevron-left"></i>
            </button>

            <button
              v-for="pageNum in visiblePages"
              :key="pageNum"
              @click="goToPage(pageNum)"
              :class="{ active: pagination.currentPage === pageNum }"
              class="pages-button"
            >
              {{ pageNum }}
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage + 1)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : 'Vai alla pagina successiva'
              "
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.totalPages)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : `Vai all'ultima pagina`
              "
            >
              <i class="fa-solid fa-angles-right"></i>
            </button>
          </div>
        </div>
      </div>

      <VueFinalModal
        v-model="showItemsModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="client-info-modal-content"
      >
        <template #default>
          <button class="modal__close icons-button" @click="closeItemsModal">
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Articoli venduti</h3>

          <!-- barra ricerca -->
          <div class="documents-search">
            <div class="search-wrapper">
              <!-- <font-awesome-icon
                class="search-icon"
                :icon="['fas', 'magnifying-glass']"
              /> -->
              <i class="fa-solid fa-magnifying-glass search-icon"></i>
              <input
                type="text"
                v-model="itemSearch"
                placeholder="Cerca un articolo…"
                class="search-doc-input"
              />
            </div>
          </div>

          <transition-group
            name="card"
            tag="div"
            class="documents-grid"
            :key="itemSearch"
          >
            <div
              v-for="it in paginatedItems"
              :key="itemKeyStable(it)"
              class="document-card"
            >
              <div class="card-link">
                <div class="card-icon">
                  <img
                    v-if="isTile(it)"
                    src="@/assets/tile.png"
                    alt=""
                    class="card-icon-img"
                  />
                  <img
                    v-else-if="isSanitary(it)"
                    src="@/assets/sanitari.png"
                    alt=""
                    class="card-icon-img"
                  />
                  <i
                    v-else
                    :class="`fa-solid ${getCategoryIcon(it)}`"
                    aria-hidden="true"
                  ></i>
                </div>

                <div class="card-body">
                  <div class="card-title">
                    {{
                      it.name ||
                      it.itemName ||
                      it.subBrand ||
                      it.brand ||
                      "Articolo"
                    }}
                  </div>

                  <div class="card-subtitle">
                    <!-- <div>
                      <strong>Nome articolo:</strong>
                      {{ it.name || it.brand || it.subBrand }}
                    </div> -->
                    <div><strong>Categoria:</strong> {{ it.category }}</div>
                    <div>
                      <strong>{{ getItemLabel(it) }}</strong>
                      <template v-if="isTile(it) && it.mqxquantity">
                        {{ Number(it.mqxquantity).toFixed(2) }} mq
                      </template>
                      <template v-else>
                        {{ it.quantity }}
                      </template>
                    </div>
                    <div v-if="it.quoteId">
                      <strong>Preventivo:</strong>
                      <router-link
                        :to="`/home/quotes/edit-quote/${it.quoteId}`"
                        @click="closeItemsModal"
                        class="card-quote-link"
                        >#{{ it.quoteId }}</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>

          <div v-if="!filteredItems.length" class="no-result">
            Nessun articolo trovato
          </div>

          <!-- Paginazione articoli -->
          <div
            v-if="itemsPagination.totalItems > 0"
            class="pagination items-modal-pagination"
          >
            <div class="pagination-left"></div>
            <div class="pagination-right">
              <div class="pagination-info">
                {{ itemsPagination.startItem }}–{{ itemsPagination.endItem }} di
                {{ itemsPagination.totalItems }}
              </div>
              <div
                v-if="itemsPagination.totalPages > 1"
                class="pagination-controls"
              >
                <button
                  class="icons-button"
                  @click="itemsPage = 1"
                  :disabled="itemsPagination.currentPage === 1"
                >
                  <i class="fa-solid fa-angles-left"></i>
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.currentPage - 1"
                  :disabled="itemsPagination.currentPage === 1"
                >
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  v-for="pageNum in visibleItemPages"
                  :key="pageNum"
                  @click="itemsPage = pageNum"
                  :class="{ active: itemsPagination.currentPage === pageNum }"
                  class="pages-button"
                >
                  {{ pageNum }}
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.currentPage + 1"
                  :disabled="
                    itemsPagination.currentPage === itemsPagination.totalPages
                  "
                >
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.totalPages"
                  :disabled="
                    itemsPagination.currentPage === itemsPagination.totalPages
                  "
                >
                  <i class="fa-solid fa-angles-right"></i>
                </button>
              </div>
            </div>
          </div>
        </template>
      </VueFinalModal>

      <VueFinalModal
        v-model="showArchiveModal"
        :clickToClose="!archiving"
        :escToClose="!archiving"
        classes="documents-modal"
        content-class="confirm-modal-content modal--archive"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeArchiveModal"
            :disabled="archiving"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Archivia cliente</h3>
          <p class="modal__subtitle">
            Sei sicuro di voler archiviare
            <strong>{{ selectedClient?.clientName }}</strong
            >?
          </p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="closeArchiveModal"
              :disabled="archiving"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="confirmArchive"
              :disabled="archiving"
            >
              <span v-if="archiving">Archivia…</span>
              <span v-else>Archivia</span>
            </button>
          </div>
        </template>
      </VueFinalModal>

      <DettaglioModal
        v-model:show="dettaglio.show"
        :titolo="dettaglio.titolo"
        :gruppi="dettaglio.gruppi"
        :loading="dettaglio.loading"
      />
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { indirizziDiConsegna } from "@/utilities/cliente";
import { dettaglioCliente } from "@/utilities/dettaglio";
import dettaglioRiga from "@/mixins/dettaglioRiga";
import DettaglioModal from "@/components/DettaglioModal.vue";
import AzioniRiga from "@/components/AzioniRiga.vue";
import { linkMaps } from "@/utilities/indirizzo";
import {
  formatToLocalDate,
  formatToLocalDateAndHours,
} from "../utilities/formatting";

export default {
  components: { DettaglioModal, AzioniRiga },
  mixins: [dettaglioRiga],
  computed: {
    ...mapGetters({
      allClients: "clients/list",
      pagination: "clients/pagination",
    }),

    visiblePages() {
      const range = 2;
      const start = Math.max(1, this.pagination.currentPage - range);
      const end = Math.min(
        this.pagination.totalPages,
        this.pagination.currentPage + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    /* filtro live sugli articoli */
    filteredItems() {
      const q = (this.itemSearch || "").toLowerCase().trim();
      if (!q) return this.soldItems;

      return this.soldItems.filter((it) => {
        const haystack = [
          it.itemName,
          it.subBrand,
          it.name,
          it.brand,
          it.category,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return haystack.includes(q);
      });
    },

    itemsPagination() {
      const total = this.filteredItems.length;
      const totalPages = Math.ceil(total / this.itemsPerPage) || 1;
      const currentPage = Math.min(this.itemsPage, totalPages);
      return {
        currentPage,
        totalPages,
        totalItems: total,
        startItem: total === 0 ? 0 : (currentPage - 1) * this.itemsPerPage + 1,
        endItem: Math.min(currentPage * this.itemsPerPage, total),
      };
    },

    paginatedItems() {
      const { currentPage } = this.itemsPagination;
      const start = (currentPage - 1) * this.itemsPerPage;
      return this.filteredItems.slice(start, start + this.itemsPerPage);
    },

    visibleItemPages() {
      const range = 2;
      const { currentPage, totalPages } = this.itemsPagination;
      const start = Math.max(1, currentPage - range);
      const end = Math.min(totalPages, currentPage + range);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  data() {
    return {
      // [sc-48860] voci aperte nella colonna Indirizzo, per il title del summary
      indirizziAperti: {},
      // clients: [],
      errorMessage: "",
      successMessage: "",
      isLoading: false,
      refreshing: false,
      refreshed: false,
      searchTerm: "",

      /* ===  MODAL Articoli  === */
      showItemsModal: false,
      soldItems: [], // array di articoli {id,itemName,quantity,price}
      itemSearch: "",
      itemsPage: 1,
      itemsPerPage: 4,
      showArchiveModal: false,
      archiving: false,
      selectedClient: null,
    };
  },
  methods: {
    // [sc-48860] voci della colonna Indirizzo: la sede legale tiene il suo link
    // (preciso per i clienti salvati con Maps), le altre lo ricavano dal testo
    indirizziCliente(client) {
      const sede = (client.legalHeadquarters?.address || "").trim();
      return [
        ...(sede
          ? [
              {
                etichetta: "Sede legale",
                nome: "indirizzo della sede legale",
                address: sede,
                link: client.legalHeadquarters.link || linkMaps(sede),
              },
            ]
          : []),
        ...indirizziDiConsegna(client).map((v) => ({
          ...v,
          nome: `indirizzo di ${v.etichetta.toLowerCase()}`,
          link: linkMaps(v.address),
        })),
      ];
    },
    ...mapActions(["fetchClients", "archiveClient", "fetchClientSoldItems"]),

    async handleRefresh() {
      this.refreshing = true;
      this.refreshed = false;
      try {
        await this.getClients(this.pagination.currentPage);
      } finally {
        this.refreshing = false;
        this.refreshed = true;
        setTimeout(() => {
          this.refreshed = false;
        }, 1500);
      }
    },

    itemKeyStable(it) {
      return (
        it.id ??
        it.itemId ??
        it.code ??
        `${it.category || "x"}-${
          it.name || it.brand || it.itemName || it.subBrand || "unk"
        }`
      );
    },

    isTile(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("piastrelle") || c.includes("piastrella");
    },
    isSanitary(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("sanitari") || c.includes("sanitario");
    },
    getCategoryIcon(it) {
      const c = (it.category || "").toLowerCase();
      if (c.includes("rubinetteria")) return "fa-faucet";
      if (c.includes("box doccia")) return "fa-shower";
      if (c.includes("accessori bagno")) return "fa-bath";
      if (c.includes("parquet") || c.includes("laminati"))
        return "fa-chess-board";
      if (c.includes("rivestimenti")) return "fa-layer-group";
      if (c.includes("decking")) return "fa-border-all";
      if (c.includes("profili")) return "fa-ruler-horizontal";
      if (c.includes("scarico")) return "fa-water";
      if (c.includes("mobili")) return "fa-couch";
      if (c.includes("porte") || c.includes("infissi")) return "fa-door-open";
      return "fa-box-open";
    },

    /* etichetta quantità in mq o pezzi */
    getItemLabel(item) {
      return this.isTile(item) && item.mqxquantity
        ? "Quantità al mq: "
        : "Quantità: ";
    },

    /* apre il modal, carica gli articoli */
    async showSoldItems(client) {
      try {
        this.itemsPage = 1;
        this.showItemsModal = true;
        //  ► chiedi gli articoli al backend / store
        const resp = await this.fetchClientSoldItems(client.id);
        //  ► salva nello stato locale
        this.soldItems = resp; // resp = array di articoli
      } catch (e) {
        // console.error(e);
        this.errorMessage =
          "Impossibile caricare gli articoli di questo cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    closeItemsModal() {
      this.showItemsModal = false;
      this.soldItems = [];
      this.itemSearch = "";
      this.itemsPage = 1;
    },

    openArchiveModal(client) {
      this.selectedClient = client;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      if (this.archiving) return; // evita chiusure durante la richiesta
      this.showArchiveModal = false;
      this.selectedClient = null;
    },

    formatToLocalDate,
    formatToLocalDateAndHours,
    dettaglioCliente,

    formatAddress(address) {
      if (!address) return "Indirizzo non disponibile";
      const withCap = address.replace(/,?\s+(\d{5}\s)/, "\n$1");
      if (withCap !== address) return withCap;
      return address.replace(/,\s*/, ",\n");
    },

    async getClients(page = 1, search = this.searchTerm) {
      this.isLoading = true;
      try {
        const res = await this.fetchClients({ page, limit: 8, search });
        return res;
      } catch (error) {
        if (error?.response?.status === 404 && page !== 1) {
          // se la pagina richiesta non ha risultati, riprova la prima
          try {
            await this.fetchClients({
              page: 1,
              limit: 8,
              search,
            });
            this.pagination.currentPage = 1;
            return;
          } catch (_) {
            /* ignora, gestiamo sotto */
          }
        }

        // messaggio come per i preventivi, ma per i clienti
        if (error?.response?.status !== 404) {
          this.$nextTick(() => {
            this.errorMessage =
              error?.response?.data?.message ||
              error?.response?.data?.details ||
              "Errore nel caricamento dei clienti.";
            this.$toast.error(this.errorMessage);
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.getClients(page);
    },

    async onSearch() {
      this.isLoading = true;
      try {
        await this.getClients(1, this.searchTerm);
        // if (Array.isArray(res) && res.length === 0) {
        //   this.$toast.error("Nessun cliente per la ricerca richiesta.");
        // }
      } catch (err) {
        if (err?.response?.status !== 404) {
          const msg =
            err?.response?.data?.message ||
            err?.response?.data?.details ||
            "Errore nel caricamento dei clienti.";
          this.$toast.error(msg);
        }
      } finally {
        this.isLoading = false;
      }
    },

    async onResetSearch() {
      this.isLoading = true;
      try {
        this.searchTerm = "";
        await this.getClients(1, "");
      } catch {
        this.errorMessage = "Errore durante il reset della ricerca.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    goToEditClient(clientId) {
      this.$router.push({ name: "edit-client", params: { clientId } });
    },

    // async onArchiveClient(clientId) {
    //   // Logica per conferma e chiamata API
    //   const conferma = window.confirm(
    //     "Sei sicuro di voler archiviare il cliente?"
    //   );
    //   if (!conferma) return;

    //   try {
    //     await this.archiveClient(clientId);
    //     this.successMessage = "Cliente archiviato con successo.";
    //   } catch (err) {
    //     console.error(err);
    //     this.errorMessage = "Impossibile archiviare il cliente.";
    //   }
    // },

    async confirmArchive() {
      if (!this.selectedClient) return;
      try {
        this.archiving = true;
        // se la tua action accetta solo l'id, basta passare quello.
        await this.archiveClient(this.selectedClient.id);

        this.successMessage = "Cliente archiviato con successo.";
        this.$toast.success(this.successMessage);
        this.showArchiveModal = false;

        // ricarica lista per riflettere lo stato
        this.getClients(1);
      } catch (err) {
        console.error(err);
        this.errorMessage = "Impossibile archiviare il cliente.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.archiving = false;
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.name === "customers" && from.name !== "customers") {
        this.getClients(1);
      }
    },
    searchTerm() {
      this.onSearch();
    },
    itemSearch() {
      this.itemsPage = 1;
    },
  },
  mounted() {
    this.getClients(1);
  },
};
</script>

<style src="@/css/ClientPage.css" />
